import { createContext, useContext } from "react";

/**
 * Focus mode for the full-screen scheduling surface (Reschedule / Rebook).
 * When on, the app chrome (left nav bar, and the calendar header's salon name +
 * booking link) is hidden so the edit-calendar surface reads as a dedicated
 * full-screen screen. New Appointment (the plain drawer) leaves it off.
 */
interface SchedulingFocusValue {
  focus: boolean;
  setFocus: (focus: boolean) => void;
}

const SchedulingFocusContext = createContext<SchedulingFocusValue>({
  focus: false,
  setFocus: () => {},
});

export const SchedulingFocusProvider = SchedulingFocusContext.Provider;

export const useSchedulingFocus = () => useContext(SchedulingFocusContext);
